import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';

export class ModalGalleryThumbs {
	private readonly element: HTMLElement;
	private readonly sliderSelector = '.modal-gallery-thumbs__slider';
	private sliderElement: HTMLElement;
	private sliderSettings = (): SwiperOptions => ({
		slidesPerView: 'auto',
		spaceBetween: 5,
		watchSlidesProgress: true,
	});

	public slider: Swiper;

	constructor(element: HTMLElement) {
		if (!element) return;

		this.element = element;
		this.init();
	}

	public init = (): void => {
		this.sliderElement = this.element.querySelector(this.sliderSelector);
		if (!this.sliderElement) return;

		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
	};

	public destroy = (): void => {
		this.slider?.destroy(true, true);
	};
}
